import { useState } from "react";
import { useDarkMode } from "../context/darkModeContext";
import { states } from "../utilities/abbrState";
import { APIData } from "../models";
import { BiErrorCircle } from "react-icons/bi";
import MinimizeButton from "./MinimizeButton";
import LoadingScreen from "./LoadingScreen";
import DataDisplayElement from "./DataDisplayElement";
import DividingLine from "./DividingLine";
import "../css/DataDisplay.css";

export default function DataDisplay({
  data,
  error,
  loading,
}: {
  data: APIData | null;
  error: string;
  loading: boolean;
}) {
  const { darkMode } = useDarkMode();
  const [minimized, setMinimized] = useState(false);

  const toggleMinimized = () => {
    setMinimized((prev) => !prev);
  };

  return (
    <div
      className={
        minimized
          ? `data-display-minimized${darkMode ? "--darkmode" : ""}`
          : `data-display${darkMode ? "--darkmode" : ""}  `
      }
    >
      {error && (
        <div
          style={{
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)",
            display: "flex",
            gap: "1rem",
            alignItems: "center",
            position: "absolute",
            color: "red",
            zIndex: 100,
          }}
        >
          <BiErrorCircle style={{ fontSize: "2rem" }} /> <p>{error}</p>
        </div>
      )}
      {loading || !data ? (
        <LoadingScreen />
      ) : (
        <div
          className={
            error || loading
              ? "data-display-container--error"
              : "data-display-container"
          }
        >
          <MinimizeButton
            onClick={toggleMinimized}
            minimized={minimized}
          />
          <DataDisplayElement
            topElement
            title="LOCATION"
            text={`${data.location.city},
            ${
              states?.find((state) => state[0] === data.location.region)?.[1] ||
              data.location.region
            },
            ${data.location.postalCode}`}
            hidden={minimized}
          />
          <DividingLine />
          <DataDisplayElement
            title="IP ADDRESS"
            text={data.ip}
            hidden={minimized}
          />
          <DividingLine />
          <DataDisplayElement
            title="TIMEZONE"
            text={`UTC${data.location.timezone}`}
            hidden={minimized}
          />
          <DividingLine />
          <DataDisplayElement
            title="ISP"
            text={data.isp || ""}
            hidden={minimized}
          />
        </div>
      )}
    </div>
  );
}
